/**
 * Swatch Selector — global behaviour
 *
 * Runs on every page so the quick-add drawer (which injects HTML via
 * innerHTML and therefore doesn't re-execute inline scripts) gets the
 * same click handling and native-picker hiding as the PDP.
 */
(() => {
  // ── Hide native option-selector for whichever option the swatch-selector owns ──
  function hideNativeColorPicker() {
    document.querySelectorAll('[data-swatch-selector]').forEach((swatchEl) => {
      const optName = swatchEl.dataset.optionName;
      if (!optName) return;
      document.querySelectorAll(`.option-selector[data-option="${CSS.escape(optName)}"]`).forEach((el) => {
        el.classList.add('swatch-selector--native-hidden');
      });
    });
    // Fallback: always hide the "Color" native picker even if no swatch-selector is present yet
    document.querySelectorAll('.option-selector[data-option="Color"]').forEach((el) => {
      el.classList.add('swatch-selector--native-hidden');
    });
  }
  hideNativeColorPicker();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideNativeColorPicker);
  }
  new MutationObserver(hideNativeColorPicker).observe(document.body, { childList: true, subtree: true });

  // ── Gallery reset (show first image until user explicitly picks a color) ──
  function resetGalleryToFirst() {
    if (window.__swatchPicked) return;
    const gallery = document.querySelector('media-gallery');
    if (!gallery) return;
    const firstThumb = gallery.querySelector('.media-thumbs__item:first-child button');
    if (firstThumb) { firstThumb.click(); return; }
    const firstItem = gallery.querySelector('.media-viewer__item');
    if (firstItem && typeof gallery.customSetActiveMedia === 'function') {
      gallery.customSetActiveMedia(firstItem, false);
    }
  }
  if (!window.__swatchPicked) setTimeout(resetGalleryToFirst, 500);

  // ── One-time event wiring ───────────────────────────────────────────────
  if (window.__swatchSelectorReady) return;
  window.__swatchSelectorReady = true;

  document.addEventListener('click', (evt) => {
    const btn = evt.target.closest('[data-swatch-selector] [data-swatch-value]');
    if (!btn) return;

    const selector = btn.closest('[data-swatch-selector]');
    const value    = btn.dataset.swatchValue;

    selector.querySelectorAll('[data-swatch-value]').forEach((b) => {
      b.classList.remove('is-selected');
      b.setAttribute('aria-pressed', 'false');
    });
    btn.classList.add('is-selected');
    btn.setAttribute('aria-pressed', 'true');

    const labelEl = selector.querySelector('[data-swatch-current]');
    if (labelEl) labelEl.textContent = value;

    window.__swatchPicked = true;

    const optionName    = selector.dataset.optionName;
    const colorFieldset = document
      .querySelector('variant-picker')
      ?.querySelector(`.option-selector[data-option="${CSS.escape(optionName)}"]`);
    if (!colorFieldset) return;

    const radio = [...colorFieldset.querySelectorAll('input[type="radio"]')]
      .find((r) => r.value === value);
    if (radio) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
})();
